<template>
    <span>{{ formattedDate }}</span>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { formatDate, formatDateTime, formatTime } from '@/stores/helpers';

const props = withDefaults(
    defineProps<{
        date?: Date | null;
        format?: 'date' | 'datetime' | 'time';
        emptyText?: string;
    }>(),
    {
        format: 'date',
        emptyText: '-',
    },
);

const formattedDate = computed(() => {
    if (!props.date) return props.emptyText;

    if (!(props.date instanceof Date)) {
        console.warn('invalid Date', props.date);
        return props.emptyText;
    }

    try {
        if (props.format === 'datetime') {
            return formatDateTime(props.date);
        } else if (props.format === 'time') {
            return formatTime(props.date);
        } else {
            return formatDate(props.date);
        }
    } catch {
        return String(props.date);
    }
});
</script>
